import { render, staticRenderFns } from "./ispSimList.vue?vue&type=template&id=92e15b66"
import script from "./ispSimList.vue?vue&type=script&lang=js"
export * from "./ispSimList.vue?vue&type=script&lang=js"
import style0 from "./ispSimList.vue?vue&type=style&index=0&id=92e15b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports